export const messages = {
  en: {
    goodCashierCategory: {
      title: 'Product Categories',
      searchPlaceholder: 'Enter product name',
      productName: 'Product Name',
      productSpec: 'Specification',
      productPrice: 'Price',
      points: 'Points'
    }
  },
  zh: {
    goodCashierCategory: {
      title: '商品分类',
      searchPlaceholder: '请输入商品名称',
      productName: '商品名称',
      productSpec: '规格',
      productPrice: '价格',
      points: '积分'
    }
  }
}